<template>
  <van-popup
      position="bottom"
      closeable
      round
      @close="closeModal"
      class="produdct-select-modal"
      :style="{ 'max-height': '90%','overflow':'hidden'}"
      v-model="show"
  >
    <div>
      <div class="title">{{ designInfo.name }}</div>
      <div style="justify-content: flex-start;" class="flex-box">

        <van-image
            fit="contain"
            position="center"
            class='product-avatar' v-model="designInfo.imageOne" :src="designInfo.imageOne"
        />
<!--        <img />-->
        <div style="font-size: 14px;">
          <div class="flex-box m-b-5">帘宽：
            <van-stepper @focus="stepSelect($event)" v-model="designInfo.qiangkuan" step="0.1" :decimal-length="2"/>
          </div>
          <div class="flex-box m-b-5">帘高：
            <van-stepper @focus="stepSelect($event)" v-model="designInfo.liangao" step="0.1" :decimal-length="2"/>
          </div>
        </div>
      </div>
    </div>
    <div class="feilds">


      <div v-if="(yongLiaoList.length>0 && type != 'cart') || (yongLiaoList.length>0 && type == 'cart' && shoppingCartType == 'ZLDZ')" class="field">
        <div class="label required">用料
          <span class="required-tag">*</span>
        </div>
          <div class="yongliao-list">
              <div style="margin-bottom: 10px;" class="" v-for="(item,index) in yongLiaoList">
                  <div v-if="item.componentImageUrl" class="yongliao flex-box">
                      <img :src="item.productImageUrl||''">
                      <div class="info">
                          <div>{{ item.componentName || ''}} {{ item.productNumber || '' }}</div>
                          <div v-if="item.designType || item.productDesignType" class="flex-box flex-start">面料方向：
                              <div style="margin-bottom: 0;" class="select-item active">{{ item.designType == 'FixHeight' || item.productDesignType == 'FixHeight' ? '定高' : '定宽' }}</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="field" :key="index" v-for="(item,index) in fieldData">
        <div v-if="item.items&&item.items.length>0" :class="[item.required?'label required':'label']">{{ item.label }} {{ item.ismulti?'多选':'' }}
          <span class="required-tag" v-if="item.required">*</span>
          <span class="empty-message" v-if="item.required&&isEmpty(item,item.ismulti)">请选择{{ item.label }} </span>
        </div>
        <div v-if="item.type=='roomSelect'" class="values"> <!--:class="type=='cart'?'values disabled':'values'"-->
          <div @click="setActive(item.name,$item.value,$item.text,item.label||'')"
               :class="['item room-item flex-box',{'active':isActive(item,$item)||$item.value==mode}]"
               v-for="$item in item.items">
            <img class="icon"
                 :src="'/roomicon/'+$item.icon+(isActive(item,$item)||$item.value==mode?'-w':'-b')+'.png'"/>
            <span>{{ $item.text }}</span>
          </div>
          <div style="flex: 0 0 100px;" class="item" v-if="designInfo.auto_room">
            <input v-model="designInfo.auto_room_name"  @focus="stepSelect($event)" placeholder="输入自定义名称" class="zidingyi-input"/>
          </div>
        </div>
        <!--<div class="values img-select"  v-if="item.type=='imgSelect'" >
           <div @click="setActive(item.name,$item.value,$item.text,item.label||'')" :class="['item color-item flex-box',{'active':isActive(item,$item)}]" v-for="$item in item.items"  >
             <img :src="$item.src" />
             <span>{{$item.text}}</span>
           </div>
       </div>-->
        <div class="values img-select" v-if="item.label=='颜色分类'&&item.items&&item.items.length>0">
          <div @click="setActive(item.name,$item.id||'',$item.number||'',item.label||'',false,'',index2)"
               :class="['item color-item flex-box',{'active':isActive(item,$item)}]" v-for="($item,index2) in item.items">
            <img :src="$item.colorImageUrl"/>
            <span>{{ $item.number }}</span>
          </div>
        </div>
        <div class="values" v-if="item.label=='面料方向'">
          <div @click="setActive(item.name,$item.value,$item.text,item.label||'')"
               :class="['item select-item flex-box',{'active':isActive(item,$item)}]" v-for="$item in item.items">
            <span>{{ $item.text }}</span>
          </div>
        </div>
        <div class="values" v-if="item.label=='转角'">
          <div class="item select-item flex-box" v-for="$item in item.items">
            <span>{{ $item.text }}</span>：
            <input v-if="$item.name == 'leftRadian'" type="number" v-model="designInfo.leftRadian" class="radian-input">
            <input v-else-if="$item.name == 'rightRadian'" v-model="designInfo.rightRadian" type="number" class="radian-input">
          </div>
        </div>
        <div class="values" v-if="item.label=='粘贴方向'">
          <div @click="setActive(item.name,$item.optionValue,$item.optionDesc,item.label||'')"
               :class="['item select-item flex-box',{'active':isActive(item,$item)}]" v-for="$item in item.items">
            <span>{{ $item.optionDesc }}</span>
          </div>
        </div>
        <!--<div class="values" v-if="item.type=='select'">
          <div @click="setActive(item.name,$item.value,$item.text,item.label||'')"
               :class="['item select-item flex-box',{'active':isActive(item,$item)}]" v-for="$item in item.items">
            <span>{{ $item.text }}</span>
          </div>
        </div>-->
        <div class="values" v-if="item.label=='加工方式'">
          <div @click="setActive(item.name,$item.optionValue,$item.optionDesc,item.label||'')"
               :class="['item select-item flex-box',{'active':isActive(item,$item)}]" v-for="$item in item.items">
            <span>{{ $item.optionDesc }}</span>
          </div>
        </div>

        <div class="values" v-if="item.label=='褶倍'">
          <div @click="setActive(item.name,$item.id,$item.name,item.label||'')"
               :class="['item select-item flex-box',{'active':isActive(item,$item)}]" v-for="$item in item.items">
            <span>{{ $item.name }}</span>
          </div>
        </div>

        <div class="values" v-if="item.label=='分片方式'">
          <div @click="setActive(item.name,$item.optionValue,$item.optionDesc,item.label||'',item.ismulti||false,$item.memo||'')"
               :class="['item select-item flex-box',{'active':isActive(item,$item)}]" v-for="$item in item.items">
            <span>{{ $item.optionDesc }}</span>
          </div>
        </div>
        <div class="values img-select" v-if="item.label=='复杂加工'">
          <div @click="setActive(item.name,$item.id,$item.name,item.label||'',item.ismulti)"
               :class="['item color-item flex-box',{'active':isActive(item,$item,item.ismulti)}]" v-for="$item in item.items">
            <img :src="$item.imageUrl"/>
            <span>{{ $item.name }}</span>
          </div>
        </div>
        <div class="values img-select" v-if="item.label=='绑带'">
          <div @click="setActive(item.name,$item.id,$item.number,item.label||'')"
               :class="['item color-item flex-box',{'active':isActive(item,$item)}]" v-for="$item in item.items">
            <img :src="$item.curtainImageUrl1"/>
            <span>{{ $item.number }}</span>
          </div>
        </div>
      </div>
      <div class="desc field">
        <div class="label">备注信息</div>
        <textarea v-model="designInfo.desc" class="textarea" placeholder="请输入重要的备注信息"/>
      </div>
      <div>
      </div>
    </div>
    <van-button :disabled="errorForm" @click="confirmOrderAction" color="#f24749" type="primary" block>确认下单</van-button>
  </van-popup>
</template>
<script>
import {Toast} from "vant";

export default {
  props: {
    shoppingCarId:{
      default:"0"
    },
    curtainOrderId:{
      default:null
    },
    shoppingCartType:{
      type:String,
      default:""
    },
    type:{

    },
    yongLiaoList: {
      type: Array,
      required: true,
      default: []
    },
    designInfo: {
      type: Object,
      default: {
       
        list: []

      }

    },
    fieldData: {
      type: Array,
      required: true,
      default: [],
    },
    productModalshow: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      selectRoom: "",
      mode: "",
      colorTypeIndex: "",
      show:this.productModalshow
    };
  },
  watch:{
     productModalshow(v){
        this.show =v;
     }
  },
  computed: {
    errorForm() {

      return this.fieldData.some((item) => item.required&&item.items&&item.items.length>0 && this.isEmpty(item,item.ismulti))
    }
  },
  mounted() {
      // console.log(this.shoppingCarId,111)
      // console.log(this.shoppingCartType,111)
  },
  methods: {
    stepSelect(e) {
      e.currentTarget.select()
    },
    isEmpty(item,ismulti=false) {
       var empty
      if(!ismulti){
        empty = (!this.designInfo.list || !this.designInfo.list[item.name] || !this.designInfo.list[item.name].value);
      
      }else{
         empty = (!this.designInfo.list || !this.designInfo.list[item.name] || !this.designInfo.list[item.name][0]);
      }
      return empty

      // this.errorForm = empty;
     
    },
    isActive(item, $item,ismulti=false) {
      let value = $item.optionValue||$item.value||$item.id
      if(!ismulti){return (this.designInfo.list && this.designInfo.list[item.name] && this.designInfo.list[item.name].value) == value}
      else{
        return (this.designInfo.list && this.designInfo.list[item.name] &&  this.designInfo.list[item.name].findIndex((item1)=>item1.value==value)>-1)
      }
    },
    confirmOrderAction() {
       this.show = false
      this.$emit("", this.designInfo, 'confirm');
      this.$emit("setModalState", false);
      // 提交购物车editDesignInfo
      this.type!='cart' &&this.curtainShoppingCarAdd()
      this.type=='cart' &&this.curtainShoppingCarEdit()
    },
    closeModal() {
      this.show = false
      this.$emit("setModalState", false);
    },
    curtainShoppingCarEdit() {
      let selectedExpandItems = []
      if (this.designInfo.designCategory != 'LianTou') {

        selectedExpandItems = this.designInfo.list.fuzhaJiagong || [];
        selectedExpandItems = selectedExpandItems.map((item) => {
          return {
            id: item.value,
            name: item.text
          }
        })

      }


      let designDetailDTOS = this.yongLiaoList
      /*if(this.yongLiaoList.length > 0 && this.shoppingCartType != "ZLCPDS") {
        designDetailDTOS = this.yongLiaoList
      }*/
      // console.log(this.designInfo.list);
      this.$http.post("private/curtainShoppingCar/mod", {
        "shoppingCarId": this.shoppingCarId || 0,// 购物车id  新增不必要，编辑需要
        "curtainOrderId": this.curtainOrderId,// 编辑订单购物车
        "shoppingCartType": this.shoppingCartType == "ZLCPDS" ? "ZLCP" : this.shoppingCartType, // "ZLDZ", // 智帘成品帘，智帘定制帘
        // "id": this.designInfo.designId,// 款式id
        "id": this.$store.getters.designId,// 单色 则传 默认款式id
        "designDetailDTOS": designDetailDTOS,
        "zhuBuProductId": this.colorTypeIndex == 0 ? null : this.designInfo.list.colorType.value,// 切换单色 传入货号id
        "zhuBuProductName": this.colorTypeIndex == 0 ? null : this.designInfo.list.colorType.text,// 切换单色 传入货号
        "number": null,
        "installationLocationName": this.designInfo.auto_room ? this.designInfo.auto_room_name : this.designInfo.room_name,// 房间选择 必填
        "width": this.designInfo.qiangkuan,// 窗宽
        "height": this.designInfo.liangao, // 窗高
        "leftRadian": this.designInfo.leftRadian || '',// 左转角
        "rightRadian": this.designInfo.rightRadian || '',// 右转角
        "selectedPasteDirection": {// 选择的粘贴方向
          "optionValue": this.designInfo.list.pasteDirection && this.designInfo.list.pasteDirection.value ? this.designInfo.list.pasteDirection.value : '', // *
          "optionDesc": this.designInfo.list.pasteDirection && this.designInfo.list.pasteDirection.text ? this.designInfo.list.pasteDirection.text : '', // *
        },
        "selectedInstallationCraft": {// 选择的安装工艺  对应加工方式  单选
          "optionValue": this.designInfo.list.jiagongfangshi && this.designInfo.list.jiagongfangshi.value ? this.designInfo.list.jiagongfangshi.value : '', // *
          "optionDesc": this.designInfo.list.jiagongfangshi && this.designInfo.list.jiagongfangshi.text ? this.designInfo.list.jiagongfangshi.text : '', // *
        },
        "selectedPleatTime": {
          "id": this.designInfo.list.pleatTimes && this.designInfo.list.pleatTimes.value ? this.designInfo.list.pleatTimes.value : '',
          "name": this.designInfo.list.pleatTimes && this.designInfo.list.pleatTimes.text ? this.designInfo.list.pleatTimes.text : '',
        },
        "selectedOpenMode": { // 选择的分片方式 左开右开等 单选
          "optionValue": this.designInfo.list.fenpianfangshi && this.designInfo.list.fenpianfangshi.value ? this.designInfo.list.fenpianfangshi.value : '', // *
          "optionDesc": this.designInfo.list.fenpianfangshi && this.designInfo.list.fenpianfangshi.text ? this.designInfo.list.fenpianfangshi.text : '', // *
          "memo": this.designInfo.list.fenpianfangshi && this.designInfo.list.fenpianfangshi.memo ? this.designInfo.list.fenpianfangshi.memo : '', // *
        },
        "processType": this.designInfo.list.mianliaoDir && this.designInfo.list.mianliaoDir.value ? this.designInfo.list.mianliaoDir.value : '',
        "selectedExpandItems": selectedExpandItems,// 复杂加工
        "bangDaiProductId": this.designInfo.list.bangdai && this.designInfo.list.bangdai.value ? this.designInfo.list.bangdai.value : '',// 选择的绑带id 单选
        "bangDaiProductNumber": this.designInfo.list.bangdai && this.designInfo.list.bangdai.text ? this.designInfo.list.bangdai.text : '', // 选择的绑带 单选
        "curtainMemo": this.designInfo.desc,// 备注信息
        "imageOne": this.designInfo.imageOne,// 定制 合并的图片 ，成品的话也是传同一张
      }).then(res => {
        // console.log(res,222)
        if(res) Toast(res || '提交成功');
        this.$parent.getList();
      })
    },
    curtainShoppingCarAdd() {
        
        let selectedExpandItems = this.designInfo.list.fuzhaJiagong || [];
        selectedExpandItems = selectedExpandItems.map((item) => {
            return {
                id: item.value,
                name: item.text
            } 
        })
        // console.log(this.yongLiaoList,1111)
        // "ZLCP"  智帘成品帘, // "ZLDZ" ,智帘定制帘
        this.shoppingCartType = this.yongLiaoList.length > 0 ? "ZLDZ" : "ZLCP"
        this.designInfo.list.bangdai = this.designInfo.list.bangdai||{}
        // console.log(designDetailDTOS)
        // console.log(this.designInfo.list);
        this.$http.post("private/curtainShoppingCar/add", {
            "shoppingCarId":0,// 购物车id  新增不必要，编辑需要
            "shoppingCartType": this.shoppingCartType, // 智帘成品帘，智帘定制帘
            "designDetailDTOS": this.yongLiaoList,
            "id": this.$store.getters.designId,// 单色 则传 默认款式id
            "zhuBuProductId": this.colorTypeIndex == 0 ? null : this.designInfo.list.colorType.value,// 切换单色 传入货号id
            "zhuBuProductName": this.colorTypeIndex == 0 ? null : this.designInfo.list.colorType.text,// 切换单色 传入货号
            "number": null,
            "installationLocationName": this.designInfo.auto_room ? this.designInfo.auto_room_name : this.designInfo.room_name,// 房间选择 必填
            "width": this.designInfo.qiangkuan,// 窗宽 
            "height": this.designInfo.liangao, // 窗高
            "leftRadian": this.designInfo.leftRadian || '',// 左转角
            "rightRadian": this.designInfo.rightRadian || '',// 右转角
            "selectedPasteDirection": {// 选择的粘贴方向
              "optionValue": this.designInfo.list.pasteDirection && this.designInfo.list.pasteDirection.value ? this.designInfo.list.pasteDirection.value : '', // *
              "optionDesc": this.designInfo.list.pasteDirection && this.designInfo.list.pasteDirection.text ? this.designInfo.list.pasteDirection.text : '', // *
            },
            "selectedInstallationCraft": {// 选择的安装工艺  对应加工方式  单选
                "optionValue": this.designInfo.list.jiagongfangshi && this.designInfo.list.jiagongfangshi.value ? this.designInfo.list.jiagongfangshi.value : '', // *
                "optionDesc": this.designInfo.list.jiagongfangshi && this.designInfo.list.jiagongfangshi.text ? this.designInfo.list.jiagongfangshi.text : '', // *
            },
            "selectedOpenMode": { // 选择的分片方式 左开右开等 单选
                "optionValue": this.designInfo.list.fenpianfangshi && this.designInfo.list.fenpianfangshi.value ? this.designInfo.list.fenpianfangshi.value : '', // *
                "optionDesc": this.designInfo.list.fenpianfangshi && this.designInfo.list.fenpianfangshi.text ? this.designInfo.list.fenpianfangshi.text : '', // *
                "memo": this.designInfo.list.fenpianfangshi && this.designInfo.list.fenpianfangshi.memo ? this.designInfo.list.fenpianfangshi.memo : '', // *
            },
            "processType": this.designInfo.list.mianliaoDir && this.designInfo.list.mianliaoDir.value ? this.designInfo.list.mianliaoDir.value : '',
            "selectedPleatTime": {
                "id": this.designInfo.list.pleatTimes && this.designInfo.list.pleatTimes.value ? this.designInfo.list.pleatTimes.value : '',
                "name":this.designInfo.list.pleatTimes && this.designInfo.list.pleatTimes.text ? this.designInfo.list.pleatTimes.text : '',
            },
            "selectedExpandItems": selectedExpandItems,// 复杂加工
            "bangDaiProductId": this.designInfo.list.bangdai && this.designInfo.list.bangdai.value ? this.designInfo.list.bangdai.value : '',// 选择的绑带id 单选
            "bangDaiProductNumber": this.designInfo.list.bangdai && this.designInfo.list.bangdai.text ? this.designInfo.list.bangdai.text : '', // 选择的绑带 单选
            "curtainMemo": this.designInfo.desc,// 备注信息
            "imageOne":this.designInfo.imageOne,// 定制 合并的图片 ，成品的话也是传同一张
        }).then(res => {
            // console.log(res,222)
          if(res) Toast(res || '提交成功');


             // this.$router.replace('/cart?activeHeader=chuanglian')
        })
    },
    setActive(name, value, text, label, ismulti,memo,itemindex=0) {

      // debugger
      // console.log("zhuzhuhz",itemindex);
      let designInfo = this.designInfo || {}
      if (ismulti) {
        designInfo.list[name] =designInfo.list[name]||[]
       let index = designInfo.list[name].findIndex((item)=>item.value==value)
       if(index==-1){
          designInfo.list[name] = designInfo.list[name].concat([{value, text, label,memo}]);
       }else{
          designInfo.list[name].splice(index,1)
       }
       
      } else {
        if (name == 'selectRoom') {
          if (value == 'zidingyi') {
            this.mode = value
            this.selectRoom = '';
            designInfo.auto_room = true
            designInfo.auto_room_name = text
          } else {
            this.mode = '';
            designInfo.room_name = text
            designInfo.auto_room = false

          }
        }
        if (name == 'bangdai') {
          // 绑带需要去勾选
          let bangdai = {value, text, label,memo}
          if(designInfo.list[name] == undefined) { // 选中
            designInfo.list[name] = bangdai
          } else if(designInfo.list[name].value != value) { // 换绑带
            designInfo.list[name] = bangdai
          } else if(designInfo.list[name].value == value) { // 取消选中
            designInfo.list[name] = null
          }
        } else {
          designInfo.list[name] = designInfo.list[name] || {}
          designInfo.list[name] = {value, text, label,memo};

        }
      }

      // 颜色分类 记录选择的款式（index == 0）还是货号
        if (name == 'colorType') {
            this.colorTypeIndex = itemindex
        }
      this.$emit("editDesignInfo", designInfo,'edit',name=='colorType',itemindex);
     
    }
  }
};
</script>
<style scoped>
.produdct-select-modal {
  z-index: 2003;
  padding: 10px;
  box-sizing: border-box;
}

.product-avatar {
  max-width: 120px;
  height: 120px;
  margin-right: 20px;
}

.title {
  font-size: 16px;
  /* font-weight: 600; */
  margin-bottom: 5px;
}

.flex-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.m-b-5 {
  margin-bottom: 10px;
}

.values {
  display: flex;
  flex-wrap: wrap;
}

.feilds {
  max-height: calc(80vh - 210px);
  overflow-y: auto;
}

.field .label {
  margin-bottom: 10px;
  font-size: 12px;
  margin-top: 10px;
}

.room-item {
  font-size: 14px;
  height: 60px;
  flex: 0 0 60px;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background: #F1f1f1;
  margin-bottom: 10px;
  border-radius: 10px;
  flex-direction: column;
  font-size: 12px;
  transition: all .3s ease-in-out;
}

.room-item .icon {
  width: 20px;
  height: 20px;
  margin-bottom: 5px;
}

.color-item {
  font-size: 14px;
  height: 60px;
  flex: 0 0 60px;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background: rgba(241, 240, 240, 0.76);
  margin-bottom: 10px;
  border-radius: 10px;
  position: relative;
}

.color-item span {
     position: absolute;
    bottom: 0px;
    width: 100%;
    background: rgba(241, 240, 240, 0.26);
    font-size: 12px;
    padding: 3px 4px;
    /*white-space: nowrap;*/
    overflow: hidden;
    box-sizing: border-box;
}

.color-item.active span {
  color: #fff;
  background: rgba(58, 58, 58, 0.7) !important;
}

.required-tag {
  color: #f24749;
}

.select-item {
  background: #f8f8f8;
  padding: 5px 10px;
  font-size: 12px;
  margin-right: 10px;
  color: #090808;
  min-width: 40px;
  text-align: center;
  border-radius: 4px;
      margin-bottom: 10px;
}

.select-item.active {
  color: #fff;
  background: #535353;
}

.room-item.active {
  background: #3a3a3ab0 !important;
  color: #fff;
}

.room-item.room-item.active .van-icon {
  color: #fff;
}

.textarea {
  border: 0;
  width: 100%;
  border-radius: 6px;
  background: #f8f8f8;
  padding: 10px;
  box-sizing: border-box;
  font-size: 14px;
}

.img-select img {
  width: 100%;
  height: 100%;
}

.zidingyi-input {
  border: 1px solid #f1f1f1;
  border-radius: 2px;
  padding: 5px;
  width: 100%;
  border-radius: 4px;
  margin-top: 10px;
  font-size: 14px;
}

.radian-input {
  border: 1px solid #f1f1f1;
  border-radius: 2px;
  width: 50px;
  border-radius: 4px;
  font-size: 14px;
}

.empty-message {
  color: red;
}

.yongliao img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  object-fit: contain;
}

.yongliao .info {
  flex: 1;
  font-size: 12px;
}

.flex-start {
  justify-content: flex-start
}
.values.disabled{
  opacity: .5;
}
</style>
